import React from 'react';
import PropTypes from 'prop-types';

import * as liveCameraService from '../../../services/idverification/LiveCameraService';

import styles from './capturedevice.scss';

class PureLiveCamera extends React.PureComponent {
    static propTypes = {
        stream: PropTypes.object.isRequired,
        buttonLabel: PropTypes.string.isRequired,
        onPhoto: PropTypes.func.isRequired,
        disabled: PropTypes.bool,
        children: PropTypes.node,
    };

    static defaultProps = {
        disabled: false,
    };

    constructor(props) {
        super(props);

        this.videoRef = React.createRef();

        /**
         * These DOM elements are initialized during the React component
         * mounting and they are destroyed during the unmounting because React
         * keeps an instance of the class, even when the component is not
         * displayed on the screen.
         */
        this.canvas = null;
        this.canvasCtx = null;
        this.videoHidden = null;
    }

    componentDidMount() {
        this.canvas = document.createElement('CANVAS');

        this.canvasCtx = this.canvas.getContext('2d');
        this.videoHidden = document.createElement('VIDEO');

        this.videoHidden.autoplay = true;
        this.videoHidden.muted = true;
        this.canvas.hidden = true;

        this.setAllStreams();
    }

    componentDidUpdate() {
        this.setAllStreams();
    }

    componentWillUnmount() {
        this.canvas = null;
        this.canvasCtx = null;
        this.videoHidden = null;
    }

    capturePhoto = () => {
        const { canvas, canvasCtx, videoHidden } = this;

        if (canvas !== null && canvasCtx !== null && videoHidden !== null) {
            const { onPhoto } = this.props;

            canvas.width = videoHidden.videoWidth;
            canvas.height = videoHidden.videoHeight;

            canvasCtx.drawImage(
                videoHidden,
                0,
                0,
                canvas.width,
                canvas.height
            );

            canvas.toBlob(onPhoto, 'image/jpeg');
        }
    };

    setAllStreams() {
        const { stream } = this.props;

        liveCameraService.setStream(this.videoHidden, stream);
        liveCameraService.setStream(this.videoRef.current, stream);
    }

    render() {
        const { children, disabled, buttonLabel } = this.props;

        return (
            <div className={styles.liveCamera}>
                <div>
                    {children}
                    {/* eslint-disable-next-line jsx-a11y/media-has-caption */}
                    <video ref={this.videoRef} autoPlay muted />
                    <p className={styles.buttonWrapper}>
                        <button
                            className={`${styles.button} btn`}
                            onClick={this.capturePhoto}
                            disabled={disabled}
                        >
                            {buttonLabel}
                        </button>
                    </p>
                </div>
            </div>
        );
    }
}

function LiveCamera(props) {
    const newProps = liveCameraService.mapPropsToProps(props);

    return <PureLiveCamera {...props} {...newProps} />;
}

export { PureLiveCamera };
export default LiveCamera;
